<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <v-layout mb-4>
                    <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
                        <span>แบบฟอร์ม</span>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <v-layout pa-6 mt-3 style="background-color: #3E7662;">
                            <v-flex d-flex justify-start align-center style="font-size: 28px;color: white">
                                <div style="font-weight: bold" @click="setData">หนังสือแจ้งผลการพิจารณา แก้ไขเพื่อนำเข้าพิจารณาใหม่</div>
                            </v-flex>
                            <v-flex d-flex justify-end align-center style="font-weight: bold;font-size: 13px;color: white">
                                <span>RL 02_2_2560</span>
                            </v-flex>
                        </v-layout>

                    <!-- Start Form -->
                        <v-card style="padding: 50px 70px 100px 70px">
                            <!-- Header -->
                            <v-layout>
                                <v-flex mr-4 shrink d-flex justify-start align-center>
                                    <img src="../../assets/LogoTh.png" width="124" alt="">
                                </v-flex>
                                <v-flex justify-start align-center>
                                    <!-- Text header -->
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- divider -->
                                    <v-layout mt-4>
                                        <v-flex>
                                            <v-divider style="background-color: #544A44;"></v-divider>
                                        </v-flex>
                                    </v-layout>
                                    <!-- Address -->
                                    <v-layout mt-2>
                                        <v-flex class="text-start">
                                            <span>ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>317/5ถนน ราชวิถีเขตราชเทวีกรุงเทพฯ 10400 โทรศัพท์, (662) 763-4297, (662) 763-4270โทรสาร (662) 354-9011</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/ E-mail; irbrta@yahoo.com, irbrta@amed.go.th</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout style="margin-top: 80px">
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>ที่่ IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.IRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.IRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>วัน/เดือน/ปี :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-menu
                                                    v-model="menuDatePage1"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menuDatePage1')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout pl-12 style="margin-top: 80px">
                                <v-flex style="font-weight: bold;" class="text-start">
                                    <span>เรื่อง ผลการพิจารณาโครงร่างการวิจัยและเอกสารที่เกี่ยวข้องโครงร่างการวิจัย</span>
                                </v-flex>
                            </v-layout>
                            <v-layout pl-12 mt-4>
                                <v-flex shrink mr-4 d-flex align-center style="font-weight: bold;" class="text-start">
                                    <span>เรียน</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center style="font-weight: bold;" class="text-start">
                                    <textfield-form
                                            placeholder="สังกัด"
                                            hide-detail
                                            :model="form.receiver"
                                            style="font-weight: bold"
                                            @update-data="updateData('receiver', $event)"
                                    ></textfield-form>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-10>
                                <v-flex mr-4 shrink class="text-start" style="font-weight: bold;">
                                    <span>สิ่งที่ส่งมาด้วย</span>
                                </v-flex>
                                <v-flex shrink class="text-start">
                                    <span>โครงร่างการวิจัยและเอกสารที่เกี่ยวข้อง</span>
                                </v-flex>
                            </v-layout>

                            <!-- Detail -->

                            <!-- row 1 -->
                            <v-layout pl-12 mt-12>
                                <v-flex pt-5 shrink mr-2 style="font-weight: bold;" class="text-start">
                                    <div style="text-indent: 10rem;" class="text-field-center text-field-margin">
                                        <span> ตามที่ ท่านได้ส่งโครงการวิจัย เรื่อง</span>
                                        <v-text-field placeholder="ชื่อโครงการภาษาไทย" class="d-inline-block mb-2" style="width: 36rem;" color="#3E7662" hide-details v-model="form.researchName"/>
                                        <span>รหัส</span>
                                        <v-text-field class="d-inline-block mb-2" style="width: 7rem;" color="#3E7662" hide-details v-model="form.researchCode"/>
                                        <span>เมื่อวันที่</span>
                                        <v-menu
                                                    v-model="menu_date1"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        placeholder="(วันที่พิจารณา)"
                                                        style="width: 7rem"
                                                        class="d-inline-block"
                                                        v-model="dateChange1"
                                                        readonly
                                                        item-color="#3E7662"
                                                        color="#3E7662"
                                                        dense
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    @input="selectDate($event, 'menu_date1')"
                                                    locale="th"
                                                    type="date"
                                                    color="#3E7662"
                                                    header-color="#3E7662"
                                            ></v-date-picker>
                                        </v-menu>
                                        <span> นั้น คณะอนุกรรมการฯ พิจารณาแล้วเห็นสมควรปรับปรุงแก้ไขดังนี้</span>
                                    </div>

                                </v-flex>
                            </v-layout>

                            <!-- row 2 -->
                            <v-layout pl-12 mt-12>
                                <v-flex class="text-start">
                                    <!-- Group 1 -->
                                    <v-layout>
                                        <v-flex style="font-weight: bold;">
                                            <span>ส่วนที่ 1 โครงร่างการวิจัย (Protocol)</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex>
                                            <span>ปัญหาจริยธรรมการวิจัย และข้อเสนอแนะ</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.ethicsIssue"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('ethicsIssue', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 2 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <span>ปัญหาด้านระเบียบวิธีวิจัย และข้อเสนอแนะ</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.orderIssue"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('orderIssue', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 3 -->
                                    <v-layout mt-12>
                                        <v-flex style="font-weight: bold;">
                                            <span> ส่วนที่ 2 เอกสารชี้แจงข้อมูลแก่ผู้เข้าร่วมโครงการวิจัย (Information Sheet) และหนังสือแสดงเจตนายินยอมเข้าร่วมการวิจัย (Informed Consent)</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex>
                                            <span>ปัญหาและข้อเสนอแนะเอกสารชี้แจงข้อมูล</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.documentIssue"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('documentIssue', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 4 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <span>ปัญหาและข้อเสนอแนะหนังสือแสดงเจตนายินยอมการเข้าร่วมการวิจัย</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.bookIssue"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('bookIssue', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 5 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <div style="font-weight: bold;">ส่วนที่ 3 ผู้วิจัย (Principal investigator)</div>
                                            <div style="margin-top: 5px;">การขอข้อมูลเพิ่มเติม :</div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.requestInformation"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('requestInformation', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 6 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <span>อื่นๆ เช่น เอกสารโฆษณา (ถ้ามี)</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.other"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('other', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 7 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <span>ปัญหาและข้อเสนอแนะ</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.issue"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('issue', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Group 8 -->
                                    <v-layout mt-12>
                                        <v-flex>
                                            <div style="font-weight: bold;">ส่วนที่ 4 อื่นๆ</div>
                                            <div style="margin-top: 5px;">ปัญหาและข้อเสนอแนะอื่นๆ</div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-2>
                                        <v-flex xs8>
                                            <textfield-form
                                                    hide-detail
                                                    :model="form.issue2"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('issue2', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>
                            </v-layout>

                            <!-- row 3 -->
                            <v-layout pl-12 mt-12>
                                <v-flex>
                                    <v-layout mt-6>
                                        <v-flex style="font-weight: bold; font-size: 18px" class="text-start">
                                            <span>สรุป</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout pl-6 mt-4>
                                        <v-flex class="text-start" style="font-weight: 500">
                                            <ul>
                                                <li>
                                                    <span style="text-decoration: underline;color: #3E7662;font-weight: bold">ปรับปรุงแก้ไข เพื่อเข้าพิจารณาใหม่</span>
                                                    <span> โครงร่างการวิจัยและเอกสารที่เกี่ยวข้อง </span>
                                                    <span style="color: #3E7662;font-weight: bold;">จำนวน 4 ชุด</span>
                                                </li>
                                                <li class="text-field-margin mb-2">
                                                    <span style="font-weight: bold;color: #CC3D45;">แนะนำพบอนุกรรมการที่ปรึกษา</span>
                                                    <v-text-field class="d-inline-block" style="width: 20rem;" color="#3E7662" hide-details v-model="form.reviewerName"/>
                                                    <span style="font-weight: bold;color: #CC3D45;">โทร</span>
                                                    <v-text-field class="d-inline-block" style="width: 15rem;" color="#3E7662" hide-details v-model="form.reviewerMobileNumber"/>
                                                    <span style="font-weight: bold;color: #CC3D45;">ก่อนการปรับแก้ไข</span>
                                                </li>
                                                <li>
                                                    ติดต่อสอบถามหรือขอคำปรึกษาได้ที่สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.ชั้น 5 อาคารพระมงกุฎเกล้า เวชวิทยา
                                                    วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้าเบอร์โทรศัพท์ 02-3549011 หรือ 02-7634297, 02-7634270
                                                </li>
                                            </ul>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout pl-12 mt-12>
                                <v-flex>
                                    <v-divider style="background-color: #000000;border-width: 0.5px"></v-divider>
                                </v-flex>
                            </v-layout>

                            <v-layout pl-12 mt-12>
                                <v-flex>
                                    <v-layout pl-6 mt-4>
                                        <v-flex class="text-start">
                                            <div>
                                                กรุณาทำ <span style="color:#CC3D45;font-weight: bold">กรุณาปรับปรุงโครงร่างการวิจัย และส่ง 4ชุด (ดำเนินการเช่นเดียวกับการส่งพิจารณาครั้งแรก) [ทำ Highlight ทั้ง 4ชุด]</span>
                                            </div>
                                            <div>
                                                พร้อมทั้งใส่เวอร์ชั่นและวันที่แก้ไขโครงการวิจัยและทำสรุปข้อแก้ไขลงในแบบรายงาน RF 02_2560พร้อมทั้งส่งซีดี ที่มีโครงร่างการวิจัยเป็น word file และ pdf file จำนวน 1 แผ่น
                                                (กรุณาตรวจสอบข้อมูลของ file ทั้ง 2 ชนิด ให้ตรงกัน) ส่งที่สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ. ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า
                                            </div>
                                            <div style="margin-top: 30px">
                                                ดาวน์โหลดแบบฟอร์ม RF 02_2560 ได้ที่ <span style="color: #3E7662;font-weight: bold;">http://www.irbrta.pmk.ac.th</span>,
                                            </div>
                                            <div style="color: #3E7662;font-weight: bold;">
                                                http://www.amed.go.th/rtamed/irbrta/
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout style="padding-left: 80px;margin-top: 80px">
                                <v-spacer></v-spacer>
                                <v-flex shrink pt-5 class="text-end">
                                    <span style="font-weight: bold;">พันเอก</span>
                                </v-flex>
                                <v-flex xs5 pl-2 d-flex align-center class="text-end text-field-center" style="font-weight: bold">
                                    <v-text-field
                                            v-model="form.signature"
                                            color="#3E7662"
                                            append-icon="edit"
                                    />
                                </v-flex>
                            </v-layout>
                            <v-layout style="padding-left: 80px;">
                                <v-spacer></v-spacer>
                                <v-flex xs5 style="font-weight: bold">
                                    <div>(สุธีพานิชกุล)</div>
                                    <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัย</div>
                                    <div>กรมแพทย์ทหารบก</div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>


                        </v-card>
                    <!-- End Form -->

                        <!-- Button Save -->
                        <v-layout mt-8>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click.native="$router.go(-1)">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
<!--                                            <v-icon class="mr-3">add</v-icon>-->
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-pageAndLine="fullpageAndLine"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
    import { mapState } from "vuex";

    export default {
        name: "FormRF06",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
            TextfieldFormAppend,
        },
        data: () => ({
            isLoading: false,
            fullpageAndLine: true,
            menu_date1: false,
            menuDatePage1: '',
            disabled: false,
            form: {
                researchID : '',
                IRBTABefore : '',
                IRBTAAfter : '',
                formDate : '',
                receiver : '',
                researchName : '',
                researchCode : '',
                researchSendDate : '',
                ethicsIssue : '',
                orderIssue : '',
                documentIssue : '',
                bookIssue : '',
                requestInformation : '',
                other : '',
                issue : '',
                issue2 : '',
                reviewerName : '',
                reviewerMobileNumber : '',
                signature : '',
            },
            dateChange1: '',
            dateChange: '',
        }),
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        created() {
            // Check Permission Access
        //    if (this.user.currentRole !== 2 && this.user.currentRole !== 3) {
         //       this.$router.go(-1);
        //    }
            this.getRL02_2();
        },
        methods:{
            updateData(name, val) {
                this.form[name] = val;
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        this.$store.dispatch("FormRL/saveRL02_2", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.isLoading = false;
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // })
                            // this.isLoading = false;
                        })
                    }
                });
            },
            getRL02_2() {
                this.isLoading = true;
                this.$store.dispatch("FormRL/getRL02_2", this.$route.query.id).then(res => {
                    this.form.researchID = res.researchID;
                    this.form.IRBTABefore = res.IRBTABefore;
                    this.form.IRBTAAfter = res.IRBTAAfter;
                    this.selectDate(res.formDate,'menuDatePage1');
                    this.form.formDate = res.formDate;
                    this.form.receiver = res.receiver;
                    this.form.researchName = res.researchName;
                    this.form.researchCode = res.researchCode;
                    this.selectDate(res.researchSendDate,'menu_date1');
                    this.form.researchSendDate = res.researchSendDate;
                    this.form.ethicsIssue = res.ethicsIssue;
                    this.form.orderIssue = res.orderIssue;
                    this.form.documentIssue = res.documentIssue;
                    this.form.bookIssue = res.bookIssue;
                    this.form.requestInformation = res.requestInformation;
                    this.form.other = res.other;
                    this.form.issue = res.issue;
                    this.form.issue2 = res.issue2;
                    this.form.reviewerName = res.reviewerName;
                    this.form.reviewerMobileNumber = res.reviewerMobileNumber;
                    this.form.signature = res.signature;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            selectDate(val,name) {
                if (name === 'menu_date1') {
                    console.log(val)
                    this.menu_date1 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange1 = changeDate;
                    this.form.researchSendDate = val;
                }
                if (name === 'menuDatePage1') {
                    this.menuDatePage1 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange = changeDate;
                    this.form.formDate = val;
                }

            },
            // Change Date
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);

                sub_year = parseInt(sub_year)+543;

                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },
            setData() {
                this.form.IRBTABefore ='Test';
                this.form.IRBTAAfter ='Test';
                this.form.formDate ='2020-02-12';
                this.form.receiver ='Test';
                this.form.researchName = 'Test';
                this.form.researchCode = 'Test';
                this.form.researchSendDate = '2020-02-12';
                this.form.ethicsIssue = 'Test';
                this.form.orderIssue = 'Test';
                this.form.documentIssue = 'Test';
                this.form.bookIssue = 'Test';
                this.form.requestInformation = 'Test';
                this.form.other = 'Test';
                this.form.issue = 'Test';
                this.form.issue2 = 'Test';
                this.form.reviewerName = 'Test';
                this.form.reviewerMobileNumber = '0905545491';
                this.form.signature = 'Test';
            },
        },
    }
</script>

<style lang="scss">
    /*** Table Styles **/
    .table-style {
        .table-fill {
            background: white;
            border-radius:3px;
            border-collapse: collapse;
            margin: auto;
            padding:5px;
            width: 100%;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            animation: float 5s infinite;
            border-bottom: 5px solid #544A44;
        }

        th {
            color:#D5DDE5;;
            background:#3E7662;
            border-top:5px solid #544A44;
            border-right: 1px solid #544A44;
            font-weight: 700;
            padding:15px;
            vertical-align:middle;
        }

        /*th:first-child {*/
        /*    border-top-left-radius:3px;*/
        /*}*/

        th:last-child {
            border-top-right-radius:3px;
            border-right:none;
        }

        tr {
            border-top: 1px solid #544A44;
            border-bottom-: 1px solid #544A44;
            color:#ffffff;
        }

        /*tr:hover td {*/
        /*    background:#4E5066;*/
        /*    color:#FFFFFF;*/
        /*    border-top: 1px solid #22262e;*/
        /*}*/

        tr:first-child {
            border-top:none;
        }

        tr:last-child {
            /*border-bottom:5px solid #544A44;*/
        }

        /*tr:nth-child(odd) td {*/
        /*    background:#EBEBEB;*/
        /*}*/

        /*tr:nth-child(odd):hover td {*/
        /*    background:#4E5066;*/
        /*}*/

        tr:last-child td:first-child {
            border-bottom-left-radius:3px;
        }

        tr:last-child td:last-child {
            border-bottom-right-radius:3px;
        }

        td {
            background:#FFFFFF;
            padding:10px 30px 10px 30px;
            text-align:left;
            vertical-align:middle;
            font-weight:700;
            color: black;
            border-right: 1px solid #544A44;
        }

        td:last-child {
            border-right: 0px;
        }

        th.text-left {
            text-align: left;
        }

        th.text-center {
            text-align: center;
        }

        th.text-right {
            text-align: right;
        }

        td.text-left {
            text-align: left;
        }

        td.text-center {
            text-align: center;
        }

        td.text-right {
            text-align: right;
        }
    }
    .text-field-color {
         .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
             color: #CC3D45;
         }
    }
    .text-field-margin {
        .v-text-field {
            padding-top: 5px;
            margin: 0;
        }
    }


</style>
